import React from "react";

const Shortcuts = () => {
  return (
    <div className="shortcuts">
      <a href="#Body">Body</a>
      <a href="#Hair">Hair</a>
      <a href="#Eyes">Eyes</a>
      <a href="#Eyebrows">Eyebrows</a>
      <a href="#Mouth">Mouth</a>
      <a href="#Facial Hair">Facial Hair</a>
      <a href="#Glasses">Glasses</a>
      <a href="#Earrings">Earrings</a>
      <a href="#Necklace">Necklace</a>
      <a href="#Hats">Hats</a>
      <a href="#Clothes 1">Clothes 1</a>
      <a href="#Clothes 2">Clothes 2</a>
      <a href="#Clothes 3">Clothes 3</a>
    </div>
  );
};

export default Shortcuts;
